import React from "react"

import { heroBg, hipaa, appStoreBadge, googlePlayBadge } from "../assets"

const ClosingSection = ({ formButtonText }) => {
  const handleRequestDemoClick = () => {
    // Find the first name input field
    const firstNameInput = document.getElementById("demo-form-firstname")

    if (firstNameInput) {
      // Scroll to the input field with smooth behavior
      firstNameInput.scrollIntoView({
        behavior: "smooth",
        block: "center"
      })

      // Focus on the input field after a short delay to ensure scroll completes
      setTimeout(() => {
        firstNameInput.focus()
      }, 500)
    }
  }

  return (
    <section className="pro-closing-section" style={{ backgroundImage: `url(${heroBg})` }}>
      <div className="pro-closing-content">
        <div className="pro-closing-text">
          <div className="pro-closing-icon">
            <img src="/images/healme_logo.svg" alt="Heal.me Logo" width="96" height="96" />
          </div>

          <h2 className="pro-closing-title">
            <span>We&apos;re on a mission to turn holistic care into primary care, and </span>
            <span className="highlight">practitioners like you</span>
            <span> are leading the transformation.</span>
          </h2>

          <p className="pro-closing-subtitle">
            We&apos;re here to support your growth, so you can focus on helping others heal.
          </p>

          <button className="pro-closing-button" onClick={handleRequestDemoClick}>
            {formButtonText || "Request a demo"}
          </button>
        </div>

        <div className="pro-app-links">
          <div className="pro-hipaa-badge">
            <img src={hipaa} alt="HIPAA Compliant" width="120" height="60" />
          </div>

          <div className="pro-app-store-badge">
            <a href="https://apps.apple.com/app/id1599744549">
              <img src={appStoreBadge} alt="Download on the App Store" width="135" height="45" />
            </a>
          </div>
          <div className="pro-google-play-badge">
            <a href="https://play.google.com/store/apps/details?id=me.heal.mobile">
              <img src={googlePlayBadge} alt="Get it on Google Play" width="135" height="45" />
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ClosingSection
